import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
const QrCode = ({ url, alert, title = 'admin.share_rally_description', canvasRef, }) => {
    const { t } = useTranslation();
    const content = (_jsxs(_Fragment, { children: [_jsx("div", { className: `qr-code-title${url ? '' : ' alert'}`, children: t(url ? title : alert ? alert : '') }), url && (_jsx("div", { className: "qr-code-content", children: _jsx(QRCodeCanvas, { value: url, size: 148, bgColor: "#ffffff", fgColor: "#327861", marginSize: 3, level: "M", ref: canvasRef }) }))] }));
    return url ? (_jsx("a", { href: url, target: "_blank", className: 'gr-code', children: content })) : (_jsx("div", { className: 'gr-code', children: content }));
};
export default QrCode;
